import SendMailUser from 'domains/models/send_mail_user';
import { formatToISO } from 'infras/datetime';
import { z } from 'zod';
import { StatusEnum } from './enum';

export type SendMailUserListItem = z.infer<typeof schemaSendMailUserListItem>;
export const schemaSendMailUserListItem = z.object({
  id: z.number(),
  userId: z.string().nullable(),
  uid: z.string(),
  name: z.string(),
  email: z.string(),
  company: z.string().nullable(),
  status: StatusEnum,
  sort: z.number(),
  locale: z.string(),
  color: z.string(),
  respondedAt: z.string().nullable(),
});

export const toListItem = (sendMailUser: SendMailUser) => {
  const listItem: SendMailUserListItem = {
    id: sendMailUser.id!,
    uid: sendMailUser.uid,
    userId: sendMailUser.userId,
    email: sendMailUser.email,
    name: sendMailUser.name,
    company: sendMailUser.company,
    status: sendMailUser.status,
    sort: sendMailUser.status,
    locale: sendMailUser.locale,
    color: sendMailUser.color,
    respondedAt: sendMailUser.respondedAt
      ? formatToISO(sendMailUser.respondedAt)
      : null,
  };
  return listItem;
};
